import { Link } from 'react-router-dom';

const FORMATS = ['JSON', 'XML', 'CSV', 'Excel', 'EDI', 'SOAP', 'GraphQL'];

export function TransformationDesignerPage() {
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Transformation Designer</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Field mapping, expression mapping and schema registry for payload transformation.</p>
      <Link to="/integrations" className="mt-2 inline-block text-sm text-teal-700 hover:underline dark:text-teal-400">← Integration Hub</Link>
      <div className="mt-6 grid gap-4 lg:grid-cols-2">
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <h2 className="font-medium">Supported Formats</h2>
          <ul className="mt-3 flex flex-wrap gap-2">
            {FORMATS.map((f) => (
              <li key={f} className="rounded bg-slate-100 px-3 py-1 text-sm dark:bg-slate-800">{f}</li>
            ))}
          </ul>
        </div>
        <div className="rounded-xl border p-4 dark:border-slate-700">
          <h2 className="font-medium">Sample Mapping</h2>
          <pre className="mt-3 overflow-x-auto rounded bg-slate-50 p-3 text-xs dark:bg-slate-800">{`{
  "source": "amazon.order.id",
  "target": "canonical.order.external_id",
  "transform": "identity"
}`}</pre>
        </div>
      </div>
    </div>
  );
}
